/**
 * ToolLibraryDataApi
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Value type definition
 */
export const ToolDataModuleDataContractsDeclaredValueType = {
  String: 'String',
  Boolean: 'Boolean',
  Decimal: 'Decimal',
  Integer: 'Integer',
} as const;

export type ToolDataModuleDataContractsDeclaredValueType =
  (typeof ToolDataModuleDataContractsDeclaredValueType)[keyof typeof ToolDataModuleDataContractsDeclaredValueType];
